import { MARKETING_SITE_HEADER_HEIGHT_VAR } from "@marketing/shared/lib/marketing-layout-vars";
import type { CSSProperties } from "react";

/** Dialog surface above the sticky marketing header while chrome fullscreen is active. */
export const MARKETING_LANDING_VIDEO_DIALOG_CHROME_FULLSCREEN_Z_CLASS =
	"z-[250]";

/** Fullscreen chrome controls pinned over the video surface. */
export const MARKETING_LANDING_VIDEO_FULLSCREEN_CONTROLS_CLASSNAME =
	"absolute top-4 right-4 z-[3] flex flex-row items-center gap-2";

export function marketingLandingVideoOverlayTopStyle(): CSSProperties {
	return {
		top: `var(${MARKETING_SITE_HEADER_HEIGHT_VAR}, 7rem)`,
	};
}

export function resolveMarketingLandingVideoDialogSurfaceStyle(
	isChromeFullscreen: boolean,
): CSSProperties {
	if (isChromeFullscreen) {
		return {
			top: 0,
			bottom: 0,
			left: 0,
			right: 0,
			height: "100dvh",
		};
	}

	return marketingLandingVideoOverlayTopStyle();
}
